import React from 'react';
import get from 'lodash/get';
import BlogBlocks from './BlogBlocks';
import withTrackingPropsProvider from '../../../hocs/withTrackingPropsProvider';

// returns an array of blog post data to be rendered
const getPosts = data =>
  data.map(post => ({
    href: post.link,
    id: post.id,
    image: get(
      post,
      `embedded['wp:featuredmedia'][0].mediaDetails.sizes.full.sourceUrl`,
    ),
    title: get(post, 'title.rendered'),
  }));

const BlogPosts = ({ posts, title }) => {
  // if we don't have posts - render nothing
  if (!Array.isArray(posts) || !posts.length) {
    return null;
  }

  return (
    <section>
      <BlogBlocks title={title} posts={getPosts(posts)} />
    </section>
  );
};

export default withTrackingPropsProvider(BlogPosts);
